import Crud from './crud'
import { request_list } from '@/commons/hpod';
import Vue from 'vue';

const crud = new Crud('export_requests', 'yêu cầu xuất kho');

const state = {
    ...crud.state,
    availableProducts: {},
    availableRequests: {},
};

const getters = {
    ...crud.getters,
};

const actions = {
    ...crud.actions,
    getAvailableProducts({ commit }, param) {
        return new Promise((resolve) => {
            commit('setLoading', { loading: true });
            request_list('export_requests/available_products', data => {
                commit('setAvailableProducts', data);
                commit('setLoading', { loading: false });
                resolve(data);
            }, Vue.http, param, this.state.authentication.token);
        });
    },
    getAvailableRequests({ commit }, param) {
        return new Promise((resolve) => {
            commit('setLoading', { loading: true });
            request_list('export_requests/available_requests', data => {
                commit('setAvailableRequests', data);
                commit('setLoading', { loading: false });
                resolve(data);
            }, Vue.http, param, this.state.authentication.token);
        });
    },
};

const mutations = {
    ...crud.mutations,
    setAvailableProducts(state, data) {
        state.availableProducts = data;
    },
    setAvailableRequests(state, data) {
        state.availableRequests = data;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
